import {
  Container,
  Button,
  ChoiceCard,
  IconText,
  ProgressBar,
} from '@wienenergiegithub/ui-next';
import styles from './QuestionsComponent.module.scss';
import { Button as BaseButton } from '@ariakit/react';
import { Question } from '../Question/Question';
import { RegulatorInfo } from '../RegulatorInfo';
import { progressbarAreas } from '../../HeizungsCheck.config';
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const QuestionsComponent = ({
  handleBackClick,
  handleNextClick,
  id,
  infoBoxes = null,
  instructions = null,
  name: optionLabel,
  options = null,
  progressbarArea = null,
  subtitle = null,
  title,
}) => (
  <Container
    className={classNames(styles.questions, 'fade-in-animation')}
    size="lg"
  >
    <ProgressBar
      currentStep={progressbarArea}
      isNotInteractive
      steps={progressbarAreas}
    />
    <Question subtitle={subtitle} title={title} />
    <div className={styles.optionsWrapper}>
      {options?.map(({ text, param, subtext, points }) => (
        <ChoiceCard
          as={BaseButton}
          key={`answerCard-${param}`}
          onClick={() => handleNextClick(text, param, optionLabel, points)}
          subtitle={subtext}
          title={text}
        />
      ))}
    </div>
    {!!instructions && (
      <IconText glyph="info-circle" text={instructions} variant="inline" />
    )}
    {!!infoBoxes && <RegulatorInfo infoBoxes={infoBoxes} />}
    {id !== 1 && (
      <Button className={styles.backButton} onClick={handleBackClick}>
        Zurück
      </Button>
    )}
  </Container>
);

QuestionsComponent.propTypes = {
  handleBackClick: PropTypes.func,
  handleNextClick: PropTypes.func,
  id: PropTypes.number.isRequired,
  infoBoxes: PropTypes.arrayOf(
    PropTypes.shape({
      image: PropTypes.string,
      text: PropTypes.string,
      title: PropTypes.string,
      alt: PropTypes.string,
    }),
  ),
  instructions: PropTypes.string,
  name: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      param: PropTypes.number,
      text: PropTypes.string,
      points: PropTypes.number,
    }),
  ),
  progressbarArea: PropTypes.number,
  subtitle: PropTypes.string,
  title: PropTypes.string.isRequired,
};

QuestionsComponent.displayName = 'QuestionsComponent';

export { QuestionsComponent };
